import React, { useEffect, useRef, useCallback, useState } from "react";
import Download from "../../../../../modals/tools/components/scripts/download_xml";
import Revisor from "../../../../../modals/tools/components/scripts/revisor";
import {
  Bar,
  Card,
  Cards,
  Container,
  Menu,
  Relatorio,
  ReportDiv,
} from "./styles";
import {
  IoSearchOutline,
  IoCodeSlashOutline,
  IoCheckmark,
} from "react-icons/io5";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { MdOutlineBugReport } from "react-icons/md";
//import ActiveFiltersModal from "./components/filtroHover/index";
import { IoMdDownload } from "react-icons/io";
import { CiCalendar } from "react-icons/ci";
import { useReports } from "@hooks/report";
import { useProjects } from "@hooks/projects";
import Mensal from "./components/mensal";
import ContentLoader from "react-content-loader";
import axios from "axios";
import { toast } from "react-toastify";
import { useTema } from "../../../../../../hooks/theme";
import { LuFilter } from "react-icons/lu";
import Filtro from "./components/filtro";
import { useAuth } from "@hooks/auth";
import EnhancedHeader from "./components/header/index";

import XML from "../../../../../modals/xml";

export default function NFes() {
  const {
    documents,
    fetchDocuments,
    setPage,
    hasMore,
    page,
    infos,
    getInfos,
    documentType,
    documentStatus,
    handleDocumentTypeChange,
    handleDocumentStatusChange,
    loading,
    handleSearch,
  } = useReports();

  const { projeto } = useAuth();
  const { projectInfo, setXmlData } = useProjects();

  // Estados locais
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filteredDocuments, setFilteredDocuments] = useState(null);
  const [isFiltering, setIsFiltering] = useState(false);
  const [abortController, setAbortController] = useState(null);
  const [activeFilters, setActiveFilters] = useState(null);
  const [localSearchTerm, setLocalSearchTerm] = useState("");
  const [activeTool, setActiveTool] = useState(null);

  // Estados para paginação de documentos filtrados
  const [filteredPage, setFilteredPage] = useState(1);
  const [filteredHasMore, setFilteredHasMore] = useState(true);
  const [isLoadingFiltered, setIsLoadingFiltered] = useState(false);
  const [detailedFilters, setDetailedFilters] = useState(null);

  // Refs
  const searchTimeoutRef = useRef(null);
  const observer = useRef();
  const scrollContainerRef = useRef(null);
  const scrollPositionRef = useRef(0);
  // Keys
  const keyLabels = {
    total: "TOTAL DE XML",
    baixadas: "DOWNLOADS",
    canceladas: "CANCELADAS",
    faltantes: "FALTANTES",
  };

  // Handlers

  const toggleFilter = () => setIsFilterOpen((prev) => !prev);
  const handleOpenTool = (tool) => {
    setActiveTool(tool);
    // Use setTimeout para garantir que o estado foi atualizado
    setTimeout(() => {
      const toolsContainer = document.getElementById("tools");
      if (toolsContainer) {
        toolsContainer.style.display = "flex";
      } else {
        console.log("Tools container not found");
      }
    }, 0);
  };

  const handleCloseTool = () => {
    setActiveTool(null);
    document.getElementById("tools").style.display = "none";
  };
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setLocalSearchTerm(value);
  
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
  
    // Se o usuário apagar o termo de busca, preserva os filtros detalhados
    if (!value.trim()) {
      // Se já existir um conjunto de filtros detalhados salvos (por exemplo, em detailedFilters)
      if (detailedFilters) {
        // Reaplica a busca com os filtros detalhados (sem o search)
        setActiveFilters({ ...detailedFilters });
        reapplyDetailedFilters({ ...detailedFilters });
      } else {
        clearFilters();
      }
      return;
    }
  
    // Se houver termo de busca, mescle com os filtros detalhados, se houver
    searchTimeoutRef.current = setTimeout(() => {
      // Se você já tem filtros detalhados salvos, combine-os com o termo de busca
      const combinedFilters = detailedFilters
        ? { ...detailedFilters, search: value.trim() }
        : { search: value.trim() };
  
      setActiveFilters(combinedFilters);
      handleSearchSubmit();
    }, 500);
  };
  
  const reapplyDetailedFilters = async (filters) => {
    setIsFiltering(true);
    try {
      const params = new URLSearchParams();
  
      // Formata e adiciona os filtros detalhados, sem o parâmetro "search"
      const formattedStartDate = formatDateForAPI(filters.startDate);
      const formattedEndDate = formatDateForAPI(filters.endDate);
      if (formattedStartDate) params.append("startDate", formattedStartDate);
      if (formattedEndDate) params.append("endDate", formattedEndDate);
      if (filters.emiDoc) params.append("emiDoc", filters.emiDoc);
      if (filters.destDoc) params.append("destDoc", filters.destDoc);
      if (filters.cfop) params.append("cfop", filters.cfop);
      if (filters.type) params.append("type", filters.type);
      if (filters.status) params.append("status", filters.status);
  
      // Parâmetros padrão
      params.append("page", "1");
      params.append("pageSize", "100");
  
      const response = await axios.get(
        `${process.env.REACT_APP_API}/report/xml/search-filter`,
        {
          params,
          headers: { projeto: projeto._id },
        }
      );
  
      if (response.data.success) {
        const formattedResults = response.data.data.hits.map((doc) => ({
          ...doc,
          _source: { ...doc._source, isFiltered: true },
        }));
        setFilteredDocuments(formattedResults);
        setFilteredHasMore(response.data.data.hasMore);
  
        // Atualiza os filtros ativos sem o termo de busca
        const newActiveFilters = {
          ...filters,
          totalDocuments: response.data.data.totalDocsFound,
          fileId: response.data.data.fileId,
          projeto: projeto._id,
          isLoading: false,
        };
        setActiveFilters(newActiveFilters);
      }
    } catch (error) {
      console.error("Erro ao reaplicar filtros detalhados:", error);
      toast.error("Erro ao reaplicar filtros detalhados");
    } finally {
      setIsFiltering(false);
    }
  };
  
  
  const handleSearchSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    if (!localSearchTerm.trim()) {
      clearFilters();
      return;
    }

    setIsFiltering(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/report/xml/search-filter`,
        {
          params: {
            search: localSearchTerm.trim(),
            page: 1,
            pageSize: 100,
          },
          headers: { projeto: projeto._id },
        }
      );

      // Log da resposta completa

      if (response.data.success) {
        const searchResults = response.data.data.hits.map((doc) => ({
          ...doc,
          _source: {
            ...doc._source,
            isFiltered: true,
          },
        }));

        setFilteredDocuments(searchResults);
        setFilteredHasMore(response.data.data.hasMore);
        setActiveFilters({
          search: localSearchTerm.trim(),
          totalDocuments:
            response.totalDocsFound || response.debug?.totalDocsFound,
          projeto: projeto._id,
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Erro na busca:", error);
      toast.error("Erro ao realizar a busca");
    } finally {
      setIsFiltering(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchSubmit(e);
    }
  };
  const clearFilters = useCallback(() => {
    if (abortController) {
      abortController.abort();
      setAbortController(null);
    }
    console.log("Clearing filters. Current activeFilters:", activeFilters);

    setFilteredDocuments(null);
    setActiveFilters(null);
    setFilteredPage(1);
    setFilteredHasMore(true);
    setIsFiltering(false);
    setIsLoadingFiltered(false);
    setPage(1);

    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    scrollPositionRef.current = 0;

    if (observer.current) {
      observer.current.disconnect();
      observer.current = null;
    }
  }, [setPage]);

  const handleFilterResults = useCallback(
    (results) => {
      if ("abortController" in results) {
        setAbortController(results.abortController);
      }

      if ("isLoading" in results) {
        setIsFiltering(results.isLoading);
        setActiveFilters((prev) => ({
          ...prev,
          isLoading: results.isLoading,
        }));

        if (results.isLoading) {
          setFilteredDocuments(null);
        }
        return;
      }

      if (results?.hits) {
        console.log("Filter Results:", results); // Debug log
      
        const formattedResults = results.hits.map((doc) => ({
          ...doc,
          _source: {
            ...doc._source,
            isFiltered: true,
          },
        }));
      
        setFilteredDocuments(formattedResults);
        setFilteredHasMore(results.hasMore);
      
        // Atualiza os filtros detalhados e ativos
        const newDetailedFilters = {
          startDate: results.activeFilters?.startDate,
          endDate: results.activeFilters?.endDate,
          emiDoc: results.activeFilters?.emiDoc,
          destDoc: results.activeFilters?.destDoc,
          cfop: results.activeFilters?.cfop,
          type: results.activeFilters?.type,
          status: results.activeFilters?.status,
        };
        setDetailedFilters(newDetailedFilters); // Você precisará declarar este estado: useState(null)
        setActiveFilters({ ...newDetailedFilters, totalDocuments: results.totalDocsFound, fileId: results.fileId, projeto: projeto._id, isLoading: false });
      
        setIsFiltering(false);
        setFilteredPage(1);
      }
      
    },
    [projeto._id]
  );

  // Function to load more filtered documents
  const loadMoreFilteredDocuments = useCallback(async () => {
    if (!filteredDocuments || !filteredHasMore || isLoadingFiltered) return;

    setIsLoadingFiltered(true);
    try {
      const nextPage = filteredPage + 1;
      const params = new URLSearchParams();

      if (activeFilters) {
        // Add all active filters to params
        const formattedStartDate = formatDateForAPI(activeFilters.startDate);
        const formattedEndDate = formatDateForAPI(activeFilters.endDate);

        if (formattedStartDate) params.append("startDate", formattedStartDate);
        if (formattedEndDate) params.append("endDate", formattedEndDate);
        if (activeFilters.emiDoc) params.append("emiDoc", activeFilters.emiDoc);
        if (activeFilters.destDoc)
          params.append("destDoc", activeFilters.destDoc);
        if (activeFilters.cfop) params.append("cfop", activeFilters.cfop);
        if (activeFilters.type) params.append("type", activeFilters.type);
        if (activeFilters.status) params.append("status", activeFilters.status);
        if (activeFilters.search) params.append("search", activeFilters.search); // Adicionar termo de busca se existir
      }

      params.append("page", nextPage.toString());
      params.append("pageSize", "100");

      const response = await axios.get(
        `${process.env.REACT_APP_API}/report/xml/search-filter`,
        {
          params, // Usar os parâmetros construídos
          headers: { projeto: projeto._id },
        }
      );

      if (response.data.success) {
        const newDocs = response.data.data.hits.map((doc) => ({
          ...doc,
          _source: {
            ...doc._source,
            isFiltered: true,
          },
        }));

        setFilteredDocuments((prev) => [...prev, ...newDocs]);
        setFilteredHasMore(response.data.data.hasMore);
        setFilteredPage(nextPage);
      }
    } catch (error) {
      console.error("Erro ao carregar mais documentos filtrados:", error);
      toast.error("Erro ao carregar mais documentos");
    } finally {
      setIsLoadingFiltered(false);
    }
  }, [
    filteredDocuments,
    filteredHasMore,
    isLoadingFiltered,
    filteredPage,
    activeFilters,
    projeto._id,
    localSearchTerm, // Adicionar dependência
  ]);

  const lastDocumentElementRef = useCallback(
    (node) => {
      if (loading || isLoadingFiltered || isFiltering) return;
      if (!filteredHasMore) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && scrollContainerRef.current) {
          const container = scrollContainerRef.current;
          // We keep track of the scroll position before loading more
          scrollPositionRef.current = container.scrollTop;
          loadMoreFilteredDocuments();
        }
      });

      if (node) observer.current.observe(node);
    },
    [
      loading,
      isLoadingFiltered,
      isFiltering,
      filteredHasMore,
      loadMoreFilteredDocuments,
    ]
  );

  const handleDownloadIndividualXML = async (nfe) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/report/download/${nfe}`,
        {
          responseType: "blob",
        }
      );

      const contentType = response.headers["content-type"];
      if (
        !contentType.includes("application/xml") &&
        !contentType.includes("text/xml")
      ) {
        toast.error("Erro ao baixar o XML: Tipo de arquivo inválido.");
        return;
      }

      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${nfe}.xml`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("Download realizado com sucesso!");
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error("Arquivo XML não encontrado.");
      } else {
        toast.error("Erro ao baixar o XML.");
      }
      console.error("Erro ao baixar o XML:", error);
    }
  };

  const handleDownloadKeys = async () => {
    try {
      console.log("Iniciando download, filters:", activeFilters);
      console.log("Projeto ID:", projeto._id);

      if (!activeFilters?.fileId) {
        toast.error("ID do arquivo não disponível");
        console.log("FileId não encontrado:", activeFilters);
        return;
      }

      const url = `${process.env.REACT_APP_API}/report/xml/download-keys/${activeFilters.fileId}`;
      console.log("URL da requisição:", url);

      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          projeto: projeto._id,
        },
      });

      console.log("Resposta recebida:", response);

      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      const fileName = `chaves_${timestamp}.txt`;

      const blob = new Blob([response.data], { type: "text/plain" });
      const url_download = window.URL.createObjectURL(blob);

      console.log("Blob criado, iniciando download");

      const link = document.createElement("a");
      link.href = url_download;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url_download);

      toast.success("Arquivo de chaves baixado com sucesso!");
    } catch (error) {
      console.error("Erro detalhado:", error);
      console.error("Response error:", error.response);
      const errorMessage =
        error.response?.data?.message || "Erro ao baixar arquivo de chaves";
      toast.error(errorMessage);
    }
  };

  const renderActiveTool = () => {
    switch (activeTool) {
      case "download_xml":
        return (
          <Download
            status={activeTool}
            setStatus={setActiveTool}
            handleClose={handleCloseTool}
          />
        );
      case "revisor":
        return (
          <Revisor
            status={activeTool}
            setStatus={setActiveTool}
            handleClose={handleCloseTool}
          />
        );
      default:
        return null;
    }
  };

  const openModal = (data) => {
    setXmlData(data);
    document.getElementById("xml").style.display = "flex";
  };

  // DocumentLoader component
  function DocumentLoader() {
    const { theme } = useTema();
    const backgroundColor = theme === "light" ? "#f0f0f0" : "#616161";
    const foregroundColor = theme === "light" ? "#e0e0e0" : "#ecebeb";

    return (
      <ContentLoader
        speed={2}
        width={1500}
        height={50}
        viewBox="0 0 1500 50"
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
      >
        <circle cx="25" cy="25" r="5" />
        <rect x="70" y="20" rx="3" ry="3" width="130" height="6" />
        <rect x="250" y="20" rx="3" ry="3" width="400" height="6" />
        <rect x="730" y="20" rx="3" ry="3" width="100" height="6" />
        <rect x="860" y="20" rx="3" ry="3" width="200" height="6" />
      </ContentLoader>
    );
  }

  const handleDownloadPDF = async () => {
    try {
      // Add debug logs
      console.log("ActiveFilters:", activeFilters);
      console.log("FileId:", activeFilters?.fileId);

      if (!activeFilters?.fileId) {
        toast.error("ID do arquivo não disponível");
        return;
      }

      // Log the URL being called
      const url = `${process.env.REACT_APP_API}/report/xml/download-pdf/${activeFilters.fileId}?type=${activeFilters.type}&status=${activeFilters.status}`;
      console.log("Download URL:", url);

      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          projeto: projeto._id,
        },
      });

      // Check response headers and type
      console.log("Response headers:", response.headers);
      console.log("Response type:", response.data.type);

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url_download = window.URL.createObjectURL(blob);
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");

      let filename;
      switch (activeFilters?.status) {
        case "Autorizada":
          filename = "Relatório Autorizadas";
          break;
        case "Cancelada":
          filename = "Relatório Canceladas";
          break;
        default:
          filename = "Relatório Geral";
      }

      const link = document.createElement("a");
      link.href = url_download;
      link.setAttribute("download", `${filename}_${timestamp}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url_download);

      toast.success("Relatório PDF baixado com sucesso!");
    } catch (error) {
      // Melhorar o tratamento de erro
      console.error("Erro completo:", error);
      console.error("Response data:", error.response?.data);

      const errorMessage =
        error.response?.data?.message || "Erro ao baixar relatório PDF";
      toast.error(errorMessage);

      // Se receber o erro específico, sugerir ao usuário que refaça a busca
      if (
        error.response?.data?.message?.includes(
          "Arquivo de filtro não encontrado"
        )
      ) {
        toast.info(
          "Por favor, refaça a busca antes de tentar baixar novamente"
        );
      }
    }
  };
  // Effects for cleanup
  useEffect(() => {
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
      if (abortController) {
        abortController.abort();
      }
    };
  }, []);

  // Effect for scroll position restoration
  useEffect(() => {
    if (!isLoadingFiltered && filteredPage > 1) {
      scrollContainerRef.current.scrollTop = scrollPositionRef.current;
    }
  }, [filteredDocuments, isLoadingFiltered, filteredPage]);

  return (
    <>
      <Container>
        {isFilterOpen && (
          <Filtro
            onFilterApply={handleFilterResults}
            activeFilters={activeFilters}
            onClose={() => setIsFilterOpen(false)}
          />
        )}

        <ReportDiv>
          <Cards>
            {infos !== undefined &&
              Object.keys(infos).map((key, index) => (
                <Card key={index}>
                  <div className="header">
                    <p>{keyLabels[key] || key}</p>
                  </div>
                  <div className="content">{infos[key].toLocaleString()}</div>
                </Card>
              ))}
          </Cards>
          <Relatorio>
            <div className="block">
              <EnhancedHeader
                localSearchTerm={localSearchTerm}
                handleSearchChange={handleSearchChange}
                handleKeyDown={handleKeyDown}
                handleSearchSubmit={handleSearchSubmit}
                toggleFilter={toggleFilter}
                handleOpenTool={handleOpenTool}
                filters={activeFilters}
                isLoading={isFiltering}
                totalDocuments={activeFilters?.totalDocuments}
                onClearFilters={clearFilters}
                handleDownloadKeys={handleDownloadKeys}
                handleDownloadPDF={handleDownloadPDF}
                handleDownloadXML={handleDownloadIndividualXML} // Adicione esta prop
              />

              <div className="table">
                {(filteredDocuments || isFiltering) && (
                  <>
                    <div className="head">
                      <div className="colum check">
                        <div className="thumb white"></div>
                      </div>

                      <div className="colum data">
                        <CiCalendar />
                        <p>Data</p>
                      </div>

                      {/* NOVA COLUNA: Número NFE */}
                      <div className="colum numeroNfe">
                        <IoCodeSlashOutline />
                        <p>Número NFE</p>
                      </div>

                      <div className="colum chave">
                        <IoCodeSlashOutline />
                        <p>Chave</p>
                      </div>

                      <div className="colum status">
                        <IoCodeSlashOutline />
                        <p>Status</p>
                      </div>

                      <div className="colum cnpj">
                        <IoCodeSlashOutline />
                        <p>CNPJ</p>
                      </div>

                      {/* NOVA COLUNA: Emitente */}
                      <div className="colum emitente">
                        <IoCodeSlashOutline />
                        <p>Emitente</p>
                      </div>
                    </div>

                    <div className="display" ref={scrollContainerRef}>
                      {isFiltering ? (
                        Array.from({ length: 5 }).map((_, index) => (
                          <DocumentLoader key={index} />
                        ))
                      ) : filteredDocuments?.length > 0 ? (
                        filteredDocuments.map((doc, index) => {
                          // Add ref to the last item for infinite scrolling
                          const isLastItem =
                            index === filteredDocuments.length - 1;
                          return (
                            <div
                              className="items"
                              key={doc._id || index}
                              ref={isLastItem ? lastDocumentElementRef : null}
                              onClick={() => openModal(doc._source)}
                            >
                              <div className="item check">
                                <div
                                  className="thumb"
                                  style={{
                                    backgroundColor: doc._source.check
                                      ? "#07bc0c"
                                      : "",
                                  }}
                                >
                                  {doc._source.check ? (
                                    <IoCheckmark style={{ color: "white" }} />
                                  ) : null}
                                </div>
                              </div>

                              <div className="item data">
                                <p>
                                  {new Date(
                                    doc._source.dhEvento
                                  ).toLocaleDateString("pt-BR")}
                                </p>
                              </div>

                              <div className="item numeroNfe">
                                <p>{doc._source.num}</p>
                              </div>

                              <div className="item chave">
                                <p>{doc._source.chave}</p>
                              </div>

                              <div className="item status">
                                <p>{doc._source.status}</p>
                              </div>

                              <div className="item cnpj">
                                <p>{doc._source.cnpj}</p>
                              </div>

                              <div className="item emitente">
                                <p>
                                  {doc._source.emiNome ||
                                    doc._source.emit?.nome}
                                </p>
                              </div>

                              {doc._source.check && (
                                <div
                                  className="item check download"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDownloadIndividualXML(
                                      doc._source.chave
                                    );
                                  }}
                                >
                                  <IoMdDownload color="white" />
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <div className="no-results">
                          <p>Nenhum documento encontrado</p>
                        </div>
                      )}
                      {isLoadingFiltered && (
                        <div className="loading-more">
                          <DocumentLoader />
                        </div>
                      )}
                    </div>
                  </>
                )}
                {!filteredDocuments && !isFiltering && (
                  <div className="empty-state">
                    <div className="message">
                      <LuFilter size={48} opacity={0.5} />
                      <p>Utilize o filtro para visualizar os documentos</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Relatorio>
        </ReportDiv>

        {/* <Mensal /> */}
      </Container>
      <Container
        id="tools"
        style={{
          display: activeTool ? "flex" : "none",
        }}
      >
        {activeTool && <div>{renderActiveTool()}</div>}
      </Container>
    </>
  );
}

// Helper function for date formatting
function formatDateForAPI(dateObj) {
  if (!dateObj?.year) return null;

  const month = (dateObj.month + 1).toString().padStart(2, "0");
  const day = dateObj.day.toString().padStart(2, "0");
  return `${dateObj.year}-${month}-${day}T00:00:00.000Z`;
}
